import React from "react";
import { List, ListItem, Avatar, Box, Typography, ListItemButton } from "@mui/material";
import { CallMade } from "@mui/icons-material";

// Define light pastel colors
const pastelColors = ["#FFD1DC", "#FFECB3", "#C8E6C9", "#BBDEFB", "#D1C4E9", "#FFCCBC"];

const getAvatarColor = (name, index) => {
    if (!name) return pastelColors[index % pastelColors.length];
    const charCode = name.charCodeAt(0);
    return pastelColors[charCode % pastelColors.length];
};

const RecruiterList = ({ connections, searchTerm, selectedContact, setSelectedContact }) => {
    // Set the first contact as selected if no contact is selected
    React.useEffect(() => {
        if (!selectedContact && connections.length > 0) {
            setSelectedContact(connections[0]); // Set the first contact as default
        }
    }, [connections, selectedContact, setSelectedContact]);

    return (
        <List sx={{ mt: 2 }}>
            {connections
                .filter((c) => c.recruiter_name?.toLowerCase().includes(searchTerm.toLowerCase()))
                .map((contact, index, arr) => (
                    <ListItem
                        key={contact.id || index}
                        disablePadding
                        sx={{
                            borderBottom: index !== arr.length - 1 ? "1px solid #ebe6e6" : "none",
                        }}
                    >
                        <ListItemButton
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                padding: "10px 14px",
                                cursor: "pointer",
                                backgroundColor:
                                    selectedContact === contact || (selectedContact === null && index === 0)
                                        ? "#f0f0f0" // Active background color
                                        : "transparent",
                                "&:hover": {
                                    backgroundColor: "#e0e0e0", // Hover effect
                                },
                            }}
                            onClick={() => setSelectedContact(contact)}
                        >
                            <Avatar
                                sx={{
                                    bgcolor: getAvatarColor(contact.recruiter_name, index),
                                    width: 42,
                                    height: 42,
                                    fontSize: "1rem",
                                    color: "#333" // Dark text for contrast
                                }}
                            >
                                {contact.recruiter_name?.charAt(0).toUpperCase() || "?"}
                            </Avatar>

                            <Box sx={{ flexGrow: 1 }}>
                                <Typography variant="body1" fontWeight="bold" sx={{ fontSize: "16px", color: "#333" }}>
                                    {contact.recruiter_name}
                                </Typography>
                                {contact.callType && (
                                    <Typography variant="body2" color="textSecondary">
                                        <CallMade sx={{ fontSize: 16, color: "green" }} /> {contact.callType} Call
                                    </Typography>
                                )}
                            </Box>

                            <Typography variant="body2" sx={{ color: "#666", fontSize: "12px" }}>
                                {contact.duration}
                            </Typography>
                        </ListItemButton>
                    </ListItem>
                ))}
        </List>
    );
};

export default RecruiterList;
